var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeatAirlineRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "60px",
    viewBox: "0 0 53 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "72498958-1DD7-41C6-9AF5-679BD4E19B2A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MY-TRIPS---FLIGHTS-Details",
    transform: "translate(-257.000000, -2817.000000)",
    fill: "#696969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(10.000000, 1147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(214.000000, 1172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy",
    transform: "translate(33.000000, 486.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "seat-airline-regular",
    transform: "translate(0.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.67780051,2.8125 C5.67780051,1.25390625 4.41212415,0 2.83890026,0 C1.26567636,0 0,1.25390625 0,2.8125 L0,16.7460938 C0,18.46875 0.366691283,20.1679688 1.07641635,21.7265625 L10.5394172,42.65625 C12.2190999,46.359375 15.9333277,48.75 20.0379043,48.75 L25.5501023,48.75 L25.5501023,54.375 L14.1945013,54.375 C12.6212774,54.375 11.355601,55.6289062 11.355601,57.1875 C11.355601,58.7460938 12.6212774,60 14.1945013,60 L42.5835038,60 C44.1567277,60 45.4224041,58.7460938 45.4224041,57.1875 C45.4224041,55.6289062 44.1567277,54.375 42.5835038,54.375 L31.2279028,54.375 L31.2279028,48.75 L41.6372038,48.75 C45.0793703,48.75 48.1785031,46.6992188 49.5033232,43.5585938 L52.7798873,35.765625 C53.1465785,34.8984375 53.0519485,33.9023438 52.5196547,33.1289062 C51.9873609,32.3554687 51.1002046,31.875 50.1539045,31.875 L11.8878948,31.875 L10.1963834,28.125 L38.7983035,28.125 C40.3715274,28.125 41.6372038,26.8710938 41.6372038,25.3125 C41.6372038,23.7539062 40.3715274,22.5 38.7983035,22.5 L7.64137319,22.5 L6.25740931,19.4296875 C5.87888928,18.5859375 5.67780051,17.671875 5.67780051,16.7460938 L5.67780051,2.8125 Z M15.7204102,40.359375 L14.4310763,37.5 L45.8955541,37.5 L44.2631865,41.390625 C43.8255227,42.4335938 42.7845926,43.125 41.6372038,43.125 L20.0379043,43.125 C18.1689616,43.125 16.4774502,42.0351562 15.7204102,40.359375 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatAirlineRegular);
export default __webpack_public_path__ + "static/media/seat-airline-regular.475f8d78fbd722ed541900d159ce0883.svg";
export { ForwardRef as ReactComponent };